var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar flex"},[_c('div',{staticClass:"fl"},[_c('a',{on:{"click":_vm.returnPage}},[_c('i',{staticClass:"fa-angle-left"})])]),_vm._v(" "),_c('div',{staticClass:"span-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('a',{staticClass:"lk-home",on:{"click":_vm.returnHome}},[_c('i',{staticClass:"fa-home"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bfbfcbc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer2/books/books-top.vue
// module id = null
// module chunks = 